
import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'
import { capitalizeAllWords } from '~/core/ts/util/string'

import type { Location } from '~/core/ts/entity/Location'
import { Promotion } from '~/core/ts/entity/Promotion'
import { translate, translateByKey } from '~/core/ts/util/translate'

import config from '~/core/ts/server-config'

const year = config.promos.promotionYearStr

const pageHeadTitleDic: Record<string, Record<string, string>> = {
  'dia-del-padre': {
    es: `Especial REGALOS DÍA DEL PADRE ${year}`,
  },
  'dia-do-pai': {
    pt: `Dia do Pai ${year}`,
  },
  'dia-de-la-madre': {
    es: `Especial REGALOS DÍA DE LA MADRE ${year}`,
  },
  'dia-da-mae': {
    pt: `Presentes especiais para O DIA DA MÃE ${year}`,
  },
  'black-friday': {
    es: `Especial BLACK FRIDAY WELLNESS ${year} ¡Empezamos el 25/11/${year}!`,
    pt: `Especial BLACK FRIDAY WELLNESS ${year} Começamos a 25/11/${year}!`,
  },
  'especial-navidad': {
    es: `Bonos Regalos Especial Navidad ${year}`,
  },
  'especial-de-natal': {
    pt: `Vales-presente especiais de Natal ${year}`
  },
  'regalos-profesores': {
    es: 'El Mejor Regalo para Profesores',
  },
  'presentes-professores': {
    pt: 'Melhor presente para professores',
  },
}

const pageHeadTitleDicLoc: Record<string, Record<string, string>> = {
  'dia-del-padre': {
    es: 'Especial REGALOS DÍA DEL PADRE en {loc}',
  },
  'dia-do-pai': {
    pt: `Dia do Pai em {loc}`,
  },
  'dia-de-la-madre': {
    es: 'Especial REGALOS DÍA DE LA MADRE en {loc}',
  },
  'dia-da-mae': {
    pt: 'Presentes especiais para o dia da mãe em {loc}',
  },
  'black-friday': {
    es: `Especial BLACK FRIDAY WELLNESS ${year} ¡Empezamos el 25/11/${year}!`,
    pt: `Especial BLACK FRIDAY WELLNESS ${year} Começamos a 25/11/${year}!`,
  },
  'especial-navidad': {
    es: `Bonos Regalos Especial Navidad ${year} en {loc}`,
  },
  'especial-de-natal': {
    pt: `Vales-presente especiais de Natal ${year} em {loc}`,
  },
  'regalos-profesores': {
    es: 'El Mejor Regalo para Profesores en {loc}',
  },
  'presentes-professores': {
    pt: 'Melhor presente para professores em {loc}',
  },
}

const titleDic: Record<string, Record<string, string>> = {
  'black-friday': {
    es: `Especial BLACK FRIDAY WELLNESS ${year} ¡Empezamos el 25/11/${year}!`,
    pt: `Especial BLACK FRIDAY WELLNESS ${year} Começamos a 25/11/${year}!`,
  },
  'descuentos': {
    es: 'Promociones con Ofertas y Descuentos para ir al Spa',
  },
  'san-valentin': {
    es: 'Haz el regalo perfecto por San Valentín con un Spa ❤️',
  },
  'dia-dos-namorados': {
    pt: 'Ofereça o presente perfeito para o Dia dos Namorados com um Spa ❤️',
  },
  'dia-del-padre': {
    es: `Especial Regalos día del Padre ${year} ❤️`,
  },
  'dia-do-pai': {
    pt: `Presentes especiais Dia do Pai ${year} ❤️`,
  },
  'dia-de-la-madre': {
    es: `Especial Regalos día de la Madre ${year} ❤️`,
  },
  'dia-da-mae': {
    pt: `Presentes especiais para o Dia da Mãe ${year} ❤️`
  },
  'especial-navidad': {
    es: `Bonos Regalos Especial Navidad ${year}`,
  },
  'especial-de-natal': {
    pt: `Vales-presente especiais de Natal ${year}`
  },
  'regalos-profesores': {
    es: `🎁 Haz el regalo perfecto para profesores, entrenadores y cuidadores con un spa`,
  },
  'presentes-professores': {
    pt: `🎁 Oferece o presente perfeito para professores, treinadores e cuidadores: um momento de spa`,
  },
}

const titleDicLoc: Record<string, Record<string, string>> = {
  'san-valentin': {
    es: 'Regalo perfecto por San Valentín con un Spa de {loc}. ❤️',
  },
  'dia-dos-namorados': {
    pt: 'O presente perfeito para o Dia dos Namorados com um Spa em {loc}. ❤️',
  },
  'dia-del-padre': {
    es: 'Especial Regalos día del Padre en {loc} ❤️',
  },
  'dia-do-pai': {
    pt: `Presentes especiais Dia do Pai em {loc} ❤️`,
  },
  'dia-de-la-madre': {
    es: 'Especial Regalos día de la Madre en {loc} ❤️',
  },
  'dia-da-mae': {
    pt: 'Presentes especiais para o Dia da Mãe em {loc} ❤️',
  },
  'especial-navidad': {
    es: `Bonos Regalos Especial Navidad ${year} en {loc}`,
  },
  'especial-de-natal': {
    pt: `Vales-presente especiais de Natal ${year} em {loc}`
  },
  'regalos-profesores': {
    es: `🎁 Haz el regalo perfecto para profesores, entrenadores y cuidadores con un spa en {loc}`,
  },
  'presentes-professores': {
    pt: `🎁 Oferece o presente perfeito para professores, treinadores e cuidadores: um momento de spa en {loc}`,
  },
}

const metaTitleDic: Record<string, Record<string, string>> = {
  'dia-del-padre': {
    es: `Especial REGALOS DÍA DEL PADRE ${year}`,
  },
  'dia-do-pai': {
    pt: `Presentes especiais DIA DO PAI ${year}`,
  },
  'dia-de-la-madre': {
    es: `Especial REGALOS DÍA DE LA MADRE ${year}`,
  },
  'dia-da-mae': {
    pt: `Presentes especiais para o DIA DA MÃE ${year}`,
  },
  'black-friday': {
    es: `Especial Ofertas WELLNESS BLACK FRIDAY ${year}`,
    pt: `Ofertas especiais WELLNESS BLACK FRIDAY ${year}`,
  },
  'especial-navidad': {
    es: `Bonos Regalos Especial Navidad ${year}`,
  },
  'especial-de-natal': {
    pt: `Vales-presente especiais de Natal ${year}`
  },
  'regalos-profesores': {
    es: 'Regalos Originales para Profesores. Encuentra los Mejores Bonos de Spa en Spalopia.com',
  },
  'presentes-professores': {
    pt: 'Presentes originais para professores. Encontre os melhores vouchers de Spa em Spalopia.com',
  },
}

const metaTitleDicLoc: Record<string, Record<string, string>> = {
  'black-friday': {
    es: `Especial Ofertas WELLNESS BLACK FRIDAY ${year}`,
    pt: `Ofertas especiais WELLNESS BLACK FRIDAY ${year}`,
  },
  'especial-navidad': {
    es: 'Bonos Regalos Especial Navidad en {loc}',
  },
  'especial-de-natal': {
    pt: `Vales-presente especiais de Natal ${year} em {loc}`
  },
  'dia-del-padre': {
    es: 'Especial REGALOS DÍA DEL PADRE en {loc}',
  },
  'dia-do-pai': {
    pt: `Presentes especiais para o DIA DO PAI em {loc}`,
  },
  'dia-de-la-madre': {
    es: 'Especial REGALOS DÍA DE LA MADRE en {loc}',
  },
  'dia-da-mae': {
    pt: 'Presentes especiais para o DIA DA MÃE em {loc}',
  },
  'regalos-profesores': {
    es: 'Regalos Originales para Profesores. Encuentra los Mejores Bonos de Spa en {loc} en Spalopia.com',
  },
  'presentes-professores': {
    pt: 'Presentes originais para professores. Encontre os melhores vouchers de Spa em {loc} em Spalopia.com',
  },
}

const descDict: Record<string, Record<string, string>> = {
  'spa-para-embarazadas': {
    es: 'Descubre los mejores spa para embarazadas. Déjate cuidar con los mejores tratamientos para mejorar la salud de la futura mamá y la del bebé ✅',
  },
  'circuito-y-masaje': {
    es: 'Circuito spa y masaje relajante. Déjate mimar por profesionales terapeutas y disfrutar de una experiencia wellness completa. Reserva online ✅',
    // pt: 'Circuito de Spa e massagem de relaxamento. Deixe-se mimar por terapeutas profissionais e desfrute de uma experiência de bem-estar completa. Reservar online ✅',
  },
  'spa-privado': {
    es: 'Descubre los mejores spas de tu zona para disfrutar de una experiencia de spa privado, en un ambiente cálido e íntimo. Reserva online ✅',
  },
  'spa-en-pareja': {
    es: 'Descubre los mejores spa para parejas y vive de una velada romántica inolvidable con: Spa privado, masajes en pareja, cava, bombones y mucho más! ✅',
  },
  'spa-para-ninos': {
    es: 'Descubre los mejores Spa para niños. Se lo pasarán en grande en el circuito spa, acompañado de un masaje y tratamiento especial para ellos ✅',
  },
  'circuito': {
    es: 'Descubre de los mejores circuitos Spa ✅ Circuito de hidromasaje, jacuzzis de espuma, duchas de sensaciones, flotarium, sauna, baño turco...',
    // pt: 'Descubra os melhores circuitos de Spa ✅ Circuito de hidromassagem, jacuzzis de espuma, duches de sensações, flotarium, sauna, banho turco...',
  },
  'circuito-y-estancia': {
    es: 'Descubre las mejores ofertas en circuito spa con estancia. Disfruta de una escapada wellness total con estancia incluida. Reserva online ✅',
  },
  'masaje-para-dos': {
    es: 'Comparte un masaje en pareja y vive un momento relax perfecto en la mejor compañía. Masajes relajantes, orientales, terepéuticos, chocolaterapia…',
  },
  'circuito-y-ritual': {
    es: 'Circuito spa y ritual. Acompaña tu experiencia spa con un ritual exclusivo para despertar tus sentidos y descubrir un mundo de sensaciones únicas',
  },
  'circuito-spa-comida': {
    es: 'Circuito spa y comida. Relájate y recupera energía con un delicioso brunch, almuerzo o cena✅Platos completos y variadas para todos los paladares',
  },
  'black-friday': {
    es: `Black Friday ${year} el 25 de noviembre Súper Ofertas y Descuentos en Bonos Regalos, Daypass, Circuitos Spa, Masajes, Escapadas de Hotel más Spa y más.`,
    pt: `Black Friday ${year} em 25 de novembro Super Ofertas e Descontos em Vales de Oferta, Daypass, Circuitos de Spa, Massagens, Hotel e Spa Getaways e muito mais.`,
  },
  'descuentos': {
    es: 'Disfruta de las mejores promociones con Ofertas y Descuentos para ir al Spa en tu ciudad preferida.',
  },
  'descontos': {
    pt: 'Aproveite as melhores promoções com Ofertas e Descontos para ir ao Spa na sua cidade preferida.',
  },
  'san-valentin': {
    es: 'Sorprende a tu pareja con una experiencia de spa única y romántica por San Valentín ♥ Elige entre: Spa en Pareja, Spa de Noche, Spa Privado y escapada wellness de Spa + Hotel.',
  },
  'dia-dos-namorados': {
    pt: 'Surpreenda o seu parceiro com uma experiência de spa única e romântica para o Dia dos Namorados ♥ Escolha entre: Spa para Casais, Spa Noturno, Spa Privado e Spa + Hotel.',
  },
  'dia-del-padre': {
    es: 'Sorprende al papá de la casa con una experiencia de spa única y especial por su día ♥ Hemos hecho una selección especial de servicios de Spa para que puedan disfrutar de su día con un bono regalo para ir al spa.',
  },
  'dia-do-pai': {
    pt: 'Surpreenda o pai da casa com uma experiência de spa única e especial para o seu dia ♥ Fizemos uma seleção especial de serviços de spa para que ele possa desfrutar do seu dia com um vale de oferta de spa.',
  },
  'dia-de-la-madre': {
    es: 'Sorprende por el día de la Madre con una experiencia de spa única y especial por su día ♥ Hemos hecho una selección especial de servicios de Spa para sorprenderla con un bono regalo para ir al spa.',
  },
  'dia-da-mae': {
    pt: 'Surpreenda no Dia da Mãe com uma experiência de spa única e especial para o seu dia ♥ Fizemos uma seleção especial de serviços de Spa para a surpreender com um vale de oferta para ir ao spa.',
  },
  'especial-navidad': {
    es: 'Encuentra las mejores experiencias de Spa en España y Portugal para regalar a tus seres queridos',
  },
  'especial-de-natal': {
    pt: `Encontre as melhores experiências de Spa em Espanha e Portugal para oferecer aos seus entes queridos como presente.`
  },
  'regalos-profesores': {
    es: 'En Spalopia.com, encuentra el regalo perfecto para tus profesores. Con nuestros bonos de spa, podrán disfrutar de tratamientos relajantes en los mejores spas de España. ¡Haz que se sientan especiales!',
  },
  'presentes-professores': {
    pt: 'Na Spalopia.com, encontre o presente perfeito para os seus professores. Com os nossos vouchers spa, eles podem desfrutar de tratamentos relaxantes nos melhores spas de Espanha - faça-os sentir-se especiais!',
  },
}

const descDictLoc: Record<string, Record<string, string>> = {
  'descuentos':{
    es: 'Disfruta de las mejores promociones con Ofertas y Descuentos para ir al Spa en {loc} y disfruta o regala un ratito de bienestar al mejor precio.',
  },
  'descontos': {
    pt: 'Aproveite as melhores promoções com Ofertas e Descontos para ir ao Spa em {loc} e desfrutar ou mimar-se com um momento de bem-estar ao melhor preço.',
  },
  'san-valentin':{
    es: 'Sorprende a tu pareja con una experiencia de spa única y romántica por San Valentín en {loc}.♥ Elige entre: Spa en Pareja, Spa de Noche, Spa Privado y escapada wellness de Spa + Hotel.',
  },
  'dia-dos-namorados':{
    pt: 'Surpreenda o seu parceiro com uma experiência de spa única e romântica para o Dia dos Namorados em {loc} ♥ Escolha entre: Spa para Casais, Spa Noturno, Spa Privado e Spa + Hotel.',
  },
  'dia-del-padre':{
    es: 'Sorprende al papá de la casa con una experiencia de spa única y especial por su día ♥ Hemos hecho una selección especial de servicios de Spas en {loc} para que puedan disfrutar de su día con un bono regalo para ir al spa.',
  },
  'dia-do-pai': {
    pt: 'Surpreenda o pai da casa com uma experiência de spa única e especial para o seu dia ♥ Fizemos uma seleção especial de serviços de spa em {loc} para que ele possa desfrutar do seu dia com um vale de oferta de spa.',
  },
  'dia-de-la-madre':{
    es: 'Sorprende por el día de la Madre con una experiencia de spa única en {loc} por su día ♥ Hemos hecho una selección especial de servicios de Spa para que puedan disfrutar de su día con un bono regalo para ir al spa.',
  },
  'dia-da-mae': {
    pt: 'Surpreenda no Dia da Mãe com uma experiência de spa única em {loc} e especial para o seu dia ♥ Fizemos uma seleção especial de serviços de Spa para a surpreender com um vale de oferta para ir ao spa.',
  },
  'especial-navidad': {
    es: 'Encuentra las mejores experiencias de Spa en {loc} para regalar a tus seres queridos',
  },
  'especial-de-natal': {
    pt: `Encontre as melhores experiências de Spa em {loc} para oferecer aos seus entes queridos como presente.`
  },
}

export function getPromotionMetadata(
  url: string,
  promotion: Promotion | null,
  location: Location | null,
  imageUrl = ''
) {
  const { pageHeadTitle, metaDescription, metaTitle } = getTitleAndDescription(promotion, location)

  const combtitle = pageHeadTitle + ' | Spalopia.com'

  const builder = HeadMetaBuilder.create()
    .withTitle(combtitle)
    .withMetaTitle(metaTitle)
    .withMetaDescription(metaDescription)
    .withOpenGraphMeta(combtitle, metaDescription)
    .withTwitterMeta(combtitle, metaDescription)
    .withLink('canonical', url)

  if (imageUrl) {
    builder
      .withTwitterImage(imageUrl)
      .withOpenGraphImage(imageUrl)
      .withThumbnailImage(imageUrl)
  }

  return builder.get()
}

export function getTitleAndDescription(promotion: Promotion | null, location: Location | null) {
  const defaultText = capitalizeAllWords(translateByKey('special-moments'))

  const defaultMetaDescription = capitalizeAllWords(translate({
    es: 'Encuentra las mejores experiencias de Spa en España: Circuito Spa, Spa y Masaje, Spa y Brunch, Spa y Hotel... ¡Todo lo que necesitas para descansar!',
    pt: 'Encontre as melhores experiências de Spa em Espanha: Circuito de Spa, Spa e Massagem, Spa e Brunch, Spa e Hotel... Tudo o que precisa para relaxar!',
  }))

  const meta = {
    // Título usado en <title></title>
    pageHeadTitle: defaultText,

    title: defaultText,
    metaTitle: defaultText,

    metaDescription: defaultMetaDescription,
  }


  if (!promotion) {
    return meta
  }

  const locationLabel = location ? capitalizeAllWords(location.label) : ''

  const title = translate(promotion.texts).title
  const place = location ? `en ${location.label} ` : ''
  meta.metaTitle = `${title} ${place}`
  meta.title = meta.metaTitle
  meta.pageHeadTitle = meta.metaTitle

  let maybeTitle = ''
  if (locationLabel && titleDicLoc[promotion.slug]) {
    maybeTitle = translate(titleDicLoc[promotion.slug]).replaceAll('{loc}', locationLabel)
  } else if (titleDic[promotion.slug]) {
    maybeTitle = translate(titleDic[promotion.slug])
  }

  if (maybeTitle) {
    meta.title = maybeTitle
    meta.pageHeadTitle = maybeTitle
  }

  let maybeMetaTitle = ''
  if (locationLabel && metaTitleDicLoc[promotion.slug]) {
    maybeMetaTitle = translate(metaTitleDicLoc[promotion.slug]).replaceAll('{loc}', locationLabel)
  } else if (metaTitleDic[promotion.slug]) {
    maybeMetaTitle = translate(metaTitleDic[promotion.slug])
  }

  if (maybeMetaTitle) {
    meta.metaTitle = maybeMetaTitle
  }

  let maybeDesc = ''
  if (locationLabel && descDictLoc[promotion.slug]) {
    maybeDesc = translate(descDictLoc[promotion.slug]).replaceAll('{loc}', locationLabel)
  } else if (descDict[promotion.slug]) {
    maybeDesc = translate(descDict[promotion.slug])
  }

  if (maybeDesc) {
    meta.metaDescription = maybeDesc
  }

  let maybeHeadTitle = ''
  if (locationLabel && pageHeadTitleDicLoc[promotion.slug]) {
    maybeHeadTitle = translate(pageHeadTitleDicLoc[promotion.slug]).replaceAll('{loc}', locationLabel)
  } else if (pageHeadTitleDic[promotion.slug]) {
    maybeHeadTitle = translate(pageHeadTitleDic[promotion.slug])
  }

  if (maybeHeadTitle) {
    meta.pageHeadTitle = maybeHeadTitle
  }

  // Capitalize title
  meta.title = meta.title
  meta.metaTitle = meta.metaTitle

  return meta
}
